@if (breadcrumbs()) {
  @if (divider()) {
    <hr class="w-full mb-4 mt-2 border-t-[1px] border-benzGrey-200" aria-hidden="true"/>
  }
  <nav class="bg-white flex" aria-label="Buchungsinformationen" [innerHTML]="breadcrumbs()"></nav>
}
